import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import styles from "../../_css/BarGraph.module.css";

/**
 * BarGraph
 * @param {string} title - Title of the graph
 * @param {number[]} data - Array of bar values
 * @param {string[]} labels - Array of labels for x-axis
 */
const BarGraph = ({ title, data, labels }) => {
  // Prepare data for recharts
  const [chartData, setChartData] = useState(data);
  // useEffect(() => {
  //   setChartData(
  //     labels.map((label, i) => ({
  //       name: label,
  //       value: data[i],
  //     }))
  //   );
  // }, [data, labels]);

  return (
    <div className={styles.graphCard}>
      <h5 className={styles.graphTitle}>{title}</h5>
      <hr />
      {chartData && chartData.length > 0 ? (
        <div
          className={styles.reactChartsWrapper}
          style={{ width: "100%", height: 296 }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
              barCategoryGap={20}
            >
              <CartesianGrid
                stroke="#e9eef5"
                strokeDasharray="0"
                vertical={false}
              />
              <XAxis
                dataKey="name"
                tick={{ fill: "#7b8ca6", fontSize: 15 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fill: "#7b8ca6", fontSize: 15 }}
                axisLine={false}
                tickLine={false}
                domain={[0, Math.ceil(Math.max(...chartData.map(item => item.value)))]}
                tickFormatter={(v) => `$${v}`}
                width={50}
              />
              <Bar
                dataKey="value"
                fill="#2595d2"
                //   radius={[8, 8, 0, 0]}
                barSize={38}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className={styles.graphEmpty}>
          <p>No data available</p>
        </div>
      )}
    </div>
  );
};

export default BarGraph;
